( function( $ ) {

	$( function() {

		$( '.js-hide-pin' ).on( 'click', function() {
			$( this ).closest( '.box' ).remove();
		} );

		$( '.js-pin' ).on( 'click', function() {

			var $this = $( this ),
				pid = $this.data( 'pid' );

			if( $this.hasClass( '-loading' ) ) {
				return;
			}

			$this.addClass( '-loading' );

			$.ajax( {
				type: 'POST',
				dataType: 'JSON',
				url: ajax.url,
				data: {
					action: 'pin',
					pid: pid
				},
			} ).done( function( response ) {

				console.log( response );

				if( response.success == true ) {

					if( response.data == 'added' ) {

						$this.removeClass( '-not-pinned' ).addClass( '-pinned' );

					} else if( response.data == 'removed' ) {

						$this.removeClass( '-pinned' ).addClass( '-not-pinned' );
						$this.addClass( '-show-hide-btn' );

					} else {
						alert( 'Er iets verkeerd met het vastpinnen van dit bericht. Ververs de pagina en probeer het opnieuw' )
					}

				} else {

					var msg = 'Er gaat iets niet helemaal goed. Ververs de pagina en probeer het opnieuw';

					alert( msg );

				}

			} )
			.fail( function( response ) {
	
				alert( 'Er iets verkeerd met het vastpinnen van dit bericht. Ververs de pagina en probeer het opnieuw' )

			} )
			.always( function( response ) {

				$this.removeClass( '-loading' );

			} );

		} );

	} );

} ) ( jQuery );